var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_591)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.282349,
    width: 66.4354,
    height: 66.4354,
    rx: 15.0491,
    fill: "#141B3C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0926,
    y: 34.8087,
    width: 71.9071,
    height: 7.12692,
    rx: 3.56346,
    transform: "rotate(-38.5482 17.0926 34.8087)",
    fill: "#FDCC72"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.556,
    y: 50.7231,
    width: 71.9071,
    height: 6.18755,
    rx: 3.09378,
    transform: "rotate(-38.5482 13.556 50.7231)",
    fill: "#FDCC72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.48236 42.6675L20.5136 23.3716",
    stroke: "white",
    strokeWidth: 5.89403,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6283 23.5651L40.9626 46.5518",
    stroke: "white",
    strokeWidth: 5.89403,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2585 46.6971L77.2121 17.9658",
    stroke: "white",
    strokeWidth: 5.89403,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_591"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.282349,
    width: 66.4354,
    height: 66.4354,
    rx: 15.0491,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d75866bce0b1713b37c2f8038fb35eff.svg";
export { ForwardRef as ReactComponent };